<template>
  <div>
    <div>
      <b-row align-v="center" align-h="between">
        <b-col align-self="center"
          ><b-form-input
            v-model="search.title"
            placeholder="جستجو برنامه بر اساس عنوان "
            class="mb-3"
            @keypress="notSpace($event)"
          ></b-form-input
        ></b-col>
        <b-col align-self="center">
          <b-form-select
            v-model="search.priority"
            class="form-control mb-3"
            value-field="id"
            text-field="title"
            :options="priorityList"
          >
            <template #first>
              <b-form-select-option :value="null">
                انتخاب اولویت
              </b-form-select-option>
            </template>
          </b-form-select>
        </b-col>
        <b-col align-self="center">
          <b-form-select
            v-model="search.status"
            class="form-control mb-3"
            value-field="id"
            text-field="title"
            :options="statusList"
          >
            <template #first>
              <b-form-select-option :value="null"
                >انتخاب وضعیت
              </b-form-select-option>
            </template></b-form-select
          >
        </b-col>
        <b-col align-v="center" align-h="between">
          <button
            @click="updateTickets"
            type="button"
            class="btn btn-primary mb-3"
            title="جستجو"
          >
            <i class="fal fa-search pt-1" />
            جستجو
          </button>
        </b-col>
        <b-col></b-col>
      </b-row>
    </div>
    <div>
      <div v-if="loaded && tickets.length === 0">
        <div class="alert alert-primary" role="alert">
          تیکتی یافت نشد، برای افزودن تیکت
          <router-link
            :to="{ name: 'tickets-create' }"
            class="alert-link text-light-primary"
          >
            کلیک
          </router-link>
          کنید
        </div>
      </div>
    </div>
    <div v-if="loaded && tickets.length" class="card card-custom gutter-b">
      <div class="card-body">
        <div class="table-responsive">
          <table
            class="table table-head-custom table-head-bg table-borderless table-vertical-center"
          >
            <thead>
              <tr>
                <th>عنوان</th>
                <th>شماره</th>
                <th>تاریخ ثبت</th>
                <th>تاریخ به‌روزرسانی</th>
                <th>اولویت</th>
                <th>وضعیت</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="ticket in tickets" :key="ticket.id">
                <td>{{ ticket.title }}</td>
                <td>{{ ticket.id }}</td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(ticket.created_at) }}
                </td>
                <td dir="ltr" class="text-nowrap">
                  {{ formatDate(ticket.updated_at) }}
                </td>
                <td>{{ ticketPriority[ticket.priority] }}</td>
                <td>{{ ticketStatus[ticket.status] }}</td>
                <td class="text-nowrap">
                  <router-link
                    :to="{
                      name: 'tickets-show',
                      params: { id: ticket.id, title: ticket.title }
                    }"
                    class="btn btn-xs btn-outline-primary mr-1"
                  >
                    <i class="flaticon-eye"></i>
                    مشاهده
                  </router-link>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="overflow-auto mt-5" v-if="ticketsPagination.lastPage > 1">
      <b-pagination
        v-model="ticketsPagination.currentPage"
        :total-rows="ticketsPagination.total"
        :per-page="ticketsPagination.perPage"
        aria-controls="my-table"
        @input="updateTickets()"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { SET_ACTIONS } from "@/core/services/store/actions.module";
import { FETCH_TICKETS } from "@/core/services/store/tickets.module";
import { mapGetters } from "vuex";

export default {
  name: "tickets",
  data() {
    return {
      loaded: false,
      search: {
        title: "",
        priority: null,
        status: null
      }
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "پشتیبانی" }]);

    this.$store.dispatch(SET_ACTIONS, {
      links: [
        {
          name: '<i class="flaticon2-plus"></i>افزودن',
          to: { name: "tickets-create" },
          class: "btn-primary"
        }
      ]
    });
    this.updateTickets();
  },
  computed: {
    ...mapGetters([
      "tickets",
      "ticketsPagination",
      "ticketPriority",
      "ticketStatus"
    ]),
    priorityList() {
      const list = [
        { id: 1, title: "عادی" },
        { id: 2, title: "فوری" },
        { id: 3, title: "بحرانی" }
      ];
      return list;
    },
    statusList() {
      const list = [
        { id: 1, title: "باز" },
        { id: 2, title: "پاسخ داده شده" },
        { id: 3, title: "بسته شده" }
      ];
      return list;
    }
  },
  methods: {
    updateTickets() {
      this.loaded = false;
      this.$store
        .dispatch(FETCH_TICKETS, {
          priority: this.search.priority,
          status: this.search.status,
          title: this.search.title
        })
        .then(() => {
          this.loaded = true;
        })
        .catch(() => {
          this.loaded = true;
        });
    }
  }
};
</script>
